export default "__VITE_ASSET__BXMo4KxB__"